// extracted by mini-css-extract-plugin
module.exports = {"button":"BtnBack_button__CrYzS","buttonBackStep":"BtnBack_buttonBackStep__23NLZ"};